"use client";

import { useState } from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

const cards = [
  {
    id: "card_1",
    last4: "4242",
    exp: "12/25",
    isDefault: true,
  },
  {
    id: "card_2",
    last4: "2324",
    exp: "12/25",
    isDefault: false,
  },
];

export default function PaymentMethod() {
  const [selectedCard, setSelectedCard] = useState(cards[0].id);

  return (
    <div className="flex h-full w-full flex-col space-y-5 rounded-lg bg-white p-5">
      {/* Header */}
      <div className="flex w-full items-start justify-between">
        <div className="space-y-1">
          <h2 className="text-lg font-bold text-neutral-950">Payment Method</h2>
          <p className="text-xs text-neutral-500">
            Manage how you pay for your subscription
          </p>
        </div>
        <Button
          variant="minimal"
          icon
          className="text-muted hover:text-muted flex flex-row items-center gap-1.5 p-1.5 text-xs leading-normal font-bold tracking-normal hover:bg-white/30"
        >
          <i className="ri-add-line text-md pb-0.5 font-light"></i>
          Add
        </Button>
      </div>

      {/* Custom Horizontal Radio Group */}
      <div className="flex w-full flex-col gap-4">
        {cards.map((card) => {
          const isSelected = selectedCard === card.id;
          return (
            <div
              key={card.id}
              onClick={() => setSelectedCard(card.id)}
              className={cn(
                "flex w-full flex-row items-center justify-between rounded-lg p-5 transition-colors",
                isSelected
                  ? "bg-orange-50 ring-orange-500"
                  : "bg-white hover:border-neutral-400",
              )}
            >
              {/* Left: radio + card info */}
              <div className="flex flex-row items-center gap-3">
                <div
                  className={cn(
                    "size-5 shrink-0 rounded-full border-2 transition-all",
                    isSelected
                      ? "border-orange-600 bg-orange-600"
                      : "border-neutral-600",
                  )}
                >
                  {isSelected && (
                    <div className="m-[3px] size-2.5 rounded-full bg-white" />
                  )}
                </div>
                <div className="flex w-[62px] items-center justify-center rounded-[6px] bg-neutral-100">
                  <i className="ri-visa-line text-4xl text-neutral-700"></i>
                </div>

                <div className="flex flex-col items-start text-left">
                  <span className="text-sm font-semibold text-neutral-950">
                    •••• {card.last4}
                  </span>
                  <span className="text-xs text-neutral-500">
                    Expires {card.exp}
                  </span>
                </div>
              </div>

              {/* Right: Default + Delete */}
              <div className="flex items-center gap-2">
                {card.isDefault && (
                  <span className="rounded-full border px-2 py-0.5 text-xs text-neutral-500">
                    Default
                  </span>
                )}
                <button
                  className="text-neutral-400 transition-colors hover:text-red-500"
                  title="Delete"
                >
                  <i className="ri-delete-bin-line text-md font-light" />
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
